import {useSelector} from 'react-redux';
import PermissionCheck from '../../Components/PermissionCheck';
import React from 'react';
import SenAndDisabilities from './SenAndDisabilities';

const SenAndDisabilitiesTab = () => {
    const isPersonApplicant = useSelector(state => state.profilesInfo.selectedProfile.isApplicant);
    const selectedProfile = useSelector(state => state.profilesInfo.selectedProfile);

    return (
        <PermissionCheck
            permissionModule={isPersonApplicant ? 'ApplicantSEN' : 'StudentSEN'}
            studentProfile={selectedProfile}
            render={(readonly) => <SenAndDisabilities readonly={readonly}/>}
        />
    );
};

export default SenAndDisabilitiesTab;